import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import StockDetail from "./pages/StockDetail";
import Watchlist from "./pages/Watchlist";
import Calculator from "./pages/Calculator";
import Settings from "./pages/Settings";

function AppShell() {
    const location = useLocation();

    // CRITICAL race-condition guard: synchronously route to AuthCallback before
    // protected routes run their own auth checks.
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }

    return (
        <>
            <Navbar />
            <main className="min-h-[calc(100vh-4rem)]">
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/dashboard" element={
                        <ProtectedRoute><Dashboard /></ProtectedRoute>
                    } />
                    <Route path="/stock/:ticker" element={
                        <ProtectedRoute><StockDetail /></ProtectedRoute>
                    } />
                    <Route path="/watchlist" element={
                        <ProtectedRoute><Watchlist /></ProtectedRoute>
                    } />
                    <Route path="/calculator" element={
                        <ProtectedRoute><Calculator /></ProtectedRoute>
                    } />
                    <Route path="/settings" element={
                        <ProtectedRoute><Settings /></ProtectedRoute>
                    } />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </main>
            <Toaster position="top-right" />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppShell />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
